/**
 * EntityTypeFilter Component
 * Toggle bar for showing/hiding entity types in the editor
 */

import { cn } from '@/lib/utils'
import { getEntityConfig } from '@/types/document'

interface EntityTypeFilterProps {
  visibleTypes: Set<string>
  onToggle: (type: string) => void
  entityCounts: Record<string, number>
}

const FILTER_TYPES = [
  'Problem',
  'Person',
  'Decision',
  'Risk',
  'Opportunity',
  'ActionItem',
  'Constraint',
]

export function EntityTypeFilter({
  visibleTypes,
  onToggle,
  entityCounts,
}: EntityTypeFilterProps) {
  return (
    <div className="flex items-center gap-2 px-6 py-2 bg-white border-b border-warm-200">
      <span className="text-[10px] font-semibold text-text-muted uppercase tracking-wide mr-2">
        Show:
      </span>
      {FILTER_TYPES.map((type) => {
        const config = getEntityConfig(type)
        const isVisible = visibleTypes.has(type)
        const count = entityCounts[type] || 0

        return (
          <button
            key={type}
            onClick={() => onToggle(type)}
            className={cn(
              'flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-all',
              'border',
              isVisible
                ? 'bg-white border-current'
                : 'bg-transparent border-transparent opacity-40 hover:opacity-60'
            )}
            style={{
              color: config.color,
            }}
            title={`${isVisible ? 'Hide' : 'Show'} ${config.label} entities`}
          >
            <span
              className="w-4 h-4 flex items-center justify-center rounded text-[10px] font-semibold"
              style={{
                backgroundColor: config.bgColor,
              }}
            >
              {config.icon}
            </span>
            <span>{config.label}</span>
            {count > 0 && (
              <span
                className="px-1.5 py-0.5 rounded-full text-[10px] text-white"
                style={{
                  backgroundColor: config.color,
                }}
              >
                {count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
